import React from "react";
import { Link } from "react-router";
import { DailyIcon } from "@/features/daily/components/DailyIcon";
import { StatTile } from "@/features/daily/components/StatTile";
import type { StatTileVm } from "@/features/daily/components/stat-tile-view-model";
import type { TodayTypeFunnelVm } from "@/features/daily/components/command/today-view-model";

const LEAD_KEY = "completed";

type Props = {
    tiles: StatTileVm[];
    live: boolean;
    queueHref: string;
    conversions: TodayTypeFunnelVm[];
    conversionsFailure: string | null;
};

export const TodayKpis: React.FC<Props> = ({ tiles, live, queueHref, conversions, conversionsFailure }) => {
    const lead = tiles.find((tile) => tile.key === LEAD_KEY);
    const rest = tiles.filter((tile) => tile.key !== LEAD_KEY);
    return (
        <section className="daily-cc-kpis" aria-label="Operaciones de hoy">
            <ul className="daily-cc-kpis__list">
                {lead === undefined ? null : (
                    <li className="daily-cc-lead" data-tone={conversionsFailure === null ? lead.border : "warning"}>
                        <Link className="daily-cc-lead__link" to={queueHref} title={[lead.valueExact, ...lead.tooltip].join(" · ")}>
                            <span className="daily-cc-lead__head">
                                <span className="daily-cc-lead__label">{live ? `${lead.label} hoy` : lead.label}</span>
                                <DailyIcon name="arrow_outward" />
                            </span>
                            <span className="daily-tile__value" data-tone={lead.valueTone}>
                                <span className="daily-tile__compact" aria-hidden="true">{lead.value}</span>
                                <span className="daily-visually-hidden">{lead.valueExact}</span>
                            </span>
                            <span className="daily-cc-lead__sub">
                                {lead.meta === null ? null : <span className="daily-cc-lead__meta">{lead.meta}</span>}
                                {conversions.map((funnel) => (
                                    <span key={funnel.key} className="daily-cc-lead__conversion" title={funnel.tooltip.join(" · ")}>
                                        <b>{funnel.headlineValue}</b> {`${funnel.headlineLabel.toLowerCase()} de ${funnel.title.toLowerCase()}`}
                                    </span>
                                ))}
                                {conversionsFailure === null ? null : <span className="daily-cc-lead__failure">{conversionsFailure}</span>}
                            </span>
                        </Link>
                    </li>
                )}
                {rest.map((tile) => <StatTile key={tile.key} tile={tile} idPrefix="daily-today-tip" />)}
            </ul>
        </section>
    );
};
